export const bootstrap = require("bootstrap/dist/js/bootstrap")
